import Vue from 'vue'

// 必须在 router 与 store 之前进行 setting 的安装，
// 因为在 router 与 store 中使用了 setting 的属性
import setting from "./plugins/setting";

Vue.use(setting)  // 使用默认的配置

import utils from "./plugins/utils"

Vue.use(utils)

import store from './store'
import router from './router'
import Jquery from 'jquery'


import {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    patchRequest
} from './components/utils/axiosApi'

//  向VUE的原型上添加请求方法
Vue.prototype.$getRequest = getRequest
Vue.prototype.$postRequest = postRequest
Vue.prototype.$deleteRequest = deleteRequest
Vue.prototype.$putRequest = putRequest
Vue.prototype.$patchRequest = patchRequest
Vue.prototype.$Jquery = Jquery

import './plugins/element.js'


Vue.config.productionTip = false

import App from './App.vue'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
